// extracted by mini-css-extract-plugin
export default {"section_ig":"Dashboard__section_ig--ig-wkfL8"};